var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "balance-checker" },
    [
      _vm.info === null
        ? _c("gc-panel", { attrs: { title: _vm.trans("Balance checker") } }, [
            _c(
              "form",
              { staticClass: "form" },
              [
                _c(
                  "fieldset",
                  { staticClass: "fields" },
                  [
                    _c("gc-text-field", {
                      attrs: {
                        id: "card-id",
                        label: _vm.trans("Card number"),
                        validation: _vm.validation.cardId
                      },
                      on: {
                        blur: function($event) {
                          return _vm.formValidator.isValid("cardId")
                        },
                        keyup: function($event) {
                          _vm.cardId = _vm.clearSpaces($event.target.value)
                        }
                      },
                      model: {
                        value: _vm.cardId,
                        callback: function($$v) {
                          _vm.cardId = $$v
                        },
                        expression: "cardId"
                      }
                    }),
                    _vm._v(" "),
                    _c("gc-text-field", {
                      attrs: {
                        id: "verification-code",
                        label: _vm.trans("Pincode"),
                        validation: _vm.validation.verificationCode
                      },
                      on: {
                        blur: function($event) {
                          return _vm.formValidator.isValid("verificationCode")
                        },
                        keyup: function($event) {
                          _vm.verificationCode = _vm.clearSpaces(
                            $event.target.value
                          )
                        }
                      },
                      model: {
                        value: _vm.verificationCode,
                        callback: function($$v) {
                          _vm.verificationCode = $$v
                        },
                        expression: "verificationCode"
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _vm.getReCaptchaSiteKey() !== null
                  ? [
                      _c(
                        "div",
                        { staticClass: "recaptcha-container" },
                        [
                          _c("vue-recaptcha", {
                            attrs: {
                              loadRecaptchaScript: true,
                              sitekey: _vm.getReCaptchaSiteKey()
                            },
                            on: {
                              verify: _vm.recaptchaVerified,
                              expired: _vm.recaptchaExpired,
                              error: _vm.recaptchaExpired
                            }
                          }),
                          _vm._v(" "),
                          this.submitted === true &&
                          _vm.recaptcha.isVerified === false
                            ? _c("gc-list", {
                                attrs: {
                                  "display-errors": true,
                                  items: ["Confirm that you are not a robot"]
                                }
                              })
                            : _vm._e()
                        ],
                        1
                      )
                    ]
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "actions" },
                  [
                    _c("gc-button", {
                      attrs: {
                        loading: _vm.loading,
                        label: _vm.trans("Check balance")
                      },
                      on: { click: _vm.getCardInfo }
                    }),
                    _vm._v(" "),
                    _vm.hasSubmitError
                      ? [
                          _c("div", {
                            staticClass: "error",
                            domProps: {
                              innerHTML: _vm._s(
                                _vm
                                  .trans("Giftcard not found")
                                  .replace("\n", "<br>")
                              )
                            }
                          })
                        ]
                      : _vm._e()
                  ],
                  2
                )
              ],
              2
            )
          ])
        : _vm.info !== null
        ? _c("gc-info-panel", {
            attrs: { info: _vm.info },
            on: { reset: _vm.resetForOtherCard }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }